// extracted by mini-css-extract-plugin
module.exports = {"visuallyHidden":"Layout_visuallyHidden__FXh5g","stars":"Layout_stars__Oi6_3","container":"Layout_container__7UE5U","spinner":"Layout_spinner__5tXpM"};